import {
  getHireJobsApplicantsRetrieveQueryOptions,
  getHireJobsRetrieveQueryOptions,
  getLocationManagersListQueryOptions,
} from "@sidegigllc/api/client";
import { queries as applicantTimelineQueries } from "domains/hire/containers/ApplicantTimelineContainer/queries";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { jobId: string; applicantId: string | undefined; locationId: number };

const APPLICANT_STALE_MS = 1000 * 60 * 5;

export const jobQuery = ({ jobId }: { jobId: string }) => getHireJobsRetrieveQueryOptions(jobId);

export const applicantQuery = ({ jobId, applicantId }: Pick<QueriesInput, "jobId" | "applicantId">) =>
  getHireJobsApplicantsRetrieveQueryOptions(jobId, applicantId ?? "", {
    query: { enabled: !!applicantId, staleTime: APPLICANT_STALE_MS },
  });

export const managersQuery = ({ locationId }: { locationId: number }) =>
  getLocationManagersListQueryOptions({ location: locationId });

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  jobQuery(input),
  applicantQuery(input),
  managersQuery(input),
  ...applicantTimelineQueries(input),
];
